import firebase from "firebase/app";
var db = firebase.firestore();
var batch = db.batch();
var gamesRef = db.collection('events')
export default {
    add: function (docObj) {
        // ADDS NEW CONTACT
        let game_uid = docObj.game_uid
        if (game_uid) {
            // If game_uid exists will save it using it as document id
            return gamesRef.doc(game_uid).set(docObj);
        } else {
            // if no id exists will create one and return document id
            return gamesRef.add(
                docObj
            ).then((docRef) => {
                return docRef.id;
            });
        }
    },
    update: function (docObj, updateObject) {
        let game_uid = docObj.game_uid // get game_uid (aka doc id)
        // To update age and favorite color:
        return gamesRef.doc(game_uid).update(updateObject)
            .then(() => {
                //console.log("Document successfully updated!");
                return "Contact successfully updated!"
            });
    },
    getAll: function () {
        return gamesRef.get()
            .then((querySnapshot) => {
                let _contacts = []
                querySnapshot.forEach((doc) => {
                    let docObj = doc.data();
                    docObj["game_uid"] = doc.id; // store doc.id as game_uid
                    _contacts.push(docObj); // push to temp array
                    //console.log(doc.id, " => ", doc.data());
                });
                return _contacts; // returns array of contacts
            })
            .catch((error) => {
                console.log("getGames() error: ", error);
            })
    },
    batchUpdate: function (arrayOfContacts, updateObject) {

        if (typeof arrayOfContacts != Array) { // checks to make sure array is is provided
            console.log('contacts batchUpdate not an array')
            return; // stop batch update
        }

        arrayOfContacts.forEach(docObj => {
            let game_uid = docObj.game_uid // get game_uid (aka doc id)
            batch.update(gamesRef.doc(game_uid), updateObject);
        })

        return batch.commit().then(() => {
            return "Contact: Batch Update Successful"
        });
    }
}